module.exports = __webpack_public_path__ + "static/media/active-farm.4d723a7d.svg";